<template>
    <div :style="'height:' + clientHeight + 'px;background: #5a6ef9;'">
        <div
            style="
                background-repeat: no-repeat;
                height: 970px;
                padding-top: 30px;
                background-size: 100% 100%;
                background-image: url(https://img.uelink.com.cn/upload/xin_li_monitor/evaluation_bg.png);
            "
        >
            <!-- <div style="width: 850px;margin: 0 auto;"> -->
            <div
                class="panel"
                style="width: 65%; margin: 0 auto; border-radius: 10px"
            >
                <div class="tit1" style="font-size: 28px; margin: 20px 0">
                    {{ name }}
                </div>
                <div
                    style="
                        display: flex;
                        align-items: center;
                        margin-bottom: 20px;
                    "
                >
                    <div
                        style="
                            font-size: 18px;
                            font-family: PingFang SC;
                            font-weight: 400;
                            line-height: 25px;
                            color: #ffffff;
                            padding: 8px 28px;
                            background-color: #5a6ef9;
                            border-radius: 20px;
                        "
                    >
                        <!-- <span v-if="answerList[topicIndex]&&answerList[topicIndex].type == 1"
                            >判断题</span
                        >
                        <span v-else>选择题</span> -->
                        <span>{{answerList[topicIndex]&&answerList[topicIndex].type == 1?'判断题' :answerList[topicIndex]&&answerList[topicIndex].type == 4?'多选题' :answerList[topicIndex]&&answerList[topicIndex].type == 3?'填空题':(answerList[topicIndex]&&answerList[topicIndex].hasExtra?'选择并填空':'选择题')}}</span>
                    </div>
                    <div
                        class="progress"
                        style="position: absolute; right: 18%; display: flex"
                    >
                        <img
                            style="
                                width: 22px;
                                height: 24px;
                                margin-right: 10px;
                            "
                            src="https://img.uelink.com.cn/upload/xin_li_monitor/progress.png"
                        />
                        <div style="line-height: 26px; font-size: 18px">
                            答题进度：{{ topicIndex + 1 }}/{{ questionNum }}
                        </div>
                    </div>
                </div>
                <van-progress
                    v-if="questionNum"
                    style="margin: 10px 0 20px"
                    :percentage="((topicIndex + 1) / questionNum) * 100"
                    stroke-width="4"
                    pivot-text=""
                    color="#5a6ef9"
                />
                <!-- <div
      v-for="(topics,index) in answerList"
      :key="index"
    > -->
                <div>
                    <div
                        style="
                            font-size: 26px;
                            font-family: PingFang SC;
                            font-weight: 600;
                            line-height: 28px;
                            margin: 40px 0;
                            color: #62666c;
                        "
                    >
                        {{ topicIndex + 1 }}、{{ answerList[topicIndex]&&answerList[topicIndex].title }}
                    </div>
                    <!-- 判断题 -->
                    <div
                        class="panel-bd option1"
                        v-if="answerList[topicIndex]&&answerList[topicIndex].type == 1"
                    >
                        <div
                            v-if="1 == answerList[topicIndex].answerIndex"
                            class="check_optionItem1"
                            style="
                                border-radius: 10px;
                                padding: 16px 30px;
                                font-size: 20px;
                                border: 1px solid #5a6ef9;
                                width: 50%;
                                margin: 10px;
                            "
                            :v-model="1"
                            @click="submit($event)"
                            data-index="1"
                        >
                            是
                        </div>
                        <div
                            v-else
                            class="optionItem1"
                            style="
                                padding: 16px 30px;
                                font-size: 20px;
                                width: 50%;
                                margin: 10px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 28px;
                                color: #62666c;
                                border: 1px solid #cbcdd1;
                                border-radius: 10px;
                            "
                            :v-model="1"
                            @click="submit($event)"
                            data-index="1"
                        >
                            是
                        </div>
                        <div
                            v-if="0 == answerList[topicIndex].answerIndex"
                            class="check_optionItem1"
                            style="
                                border-radius: 10px;
                                padding: 16px 30px;
                                font-size: 20px;
                                width: 50%;
                                border: 1px solid #5a6ef9;
                                margin: 10px;
                            "
                            :v-model="0"
                            @click="submit($event)"
                            data-index="0"
                        >
                            否
                        </div>
                        <div
                            v-else
                            class="optionItem1"
                            style="
                                padding: 16px 30px;
                                font-size: 20px;
                                width: 50%;
                                margin: 10px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 28px;
                                color: #62666c;
                                border: 1px solid #cbcdd1;
                                border-radius: 10px;
                            "
                            :v-model="0"
                            @click="submit($event)"
                            data-index="0"
                        >
                            否
                        </div>
                    </div>
                    <!-- 选择题 -->
                    <div
                        :class="
                            answerList[topicIndex].options.length > 4
                                ? 'option1'
                                : 'option2'
                        "
                        v-if="answerList[topicIndex]&&answerList[topicIndex].type == 2"
                    >
                        <div
                            v-for="(option, optionIndex) in answerList[
                                topicIndex
                            ].options"
                            :key="optionIndex"
                            :class="
                                optionIndex ==
                                answerList[topicIndex].answerIndex
                                    ? 'check_optionItem2'
                                    : 'optionItem2'
                            "
                            style="
                                width: 40%;
                                padding: 16px 30px;
                                font-size: 20px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 28px;
                                border: 1px solid #5a6ef9;
                                border-radius: 10px;
                                z-index: 200;
                                margin: 10px;
                            "
                            :v-model="optionIndex"
                            @click="submit($event)"
                            :data-index="optionIndex"
                        >
                            {{ option }}
                        </div>
                        <!-- 选择并填空 -->
                        <div
                            v-if="answerList[topicIndex].hasExtra"
                            style="
                                border: 1px solid #000000;
                                background-color: #ededed;
                            "
                        >
                            <van-field
                                placeholder="请输入"
                                v-model="answerList[topicIndex].answerExtra"
                                style="
                                    width: 610rpx;
                                    font-size: 26px;
                                    padding: 10px;
                                "
                            />
                        </div>
                    </div>
                    <!-- 多选题 -->
                    <div
                        :class="
                            answerList[topicIndex].options.length > 4
                                ? 'option1'
                                : 'option2'
                        "
                        v-if="answerList[topicIndex]&&answerList[topicIndex].type == 4"
                    >
                        <div
                            v-for="(option, optionIndex) in answerList[
                                topicIndex
                            ].options"
                            :key="optionIndex"
                            :class="
                                answerList[topicIndex].answerObj && answerList[topicIndex].answerObj[optionIndex]?'check_optionItem2' :'optionItem2'
                            "
                            style="
                                width: 40%;
                                padding: 16px 30px;
                                font-size: 20px;
                                font-family: PingFang SC;
                                font-weight: 400;
                                line-height: 28px;
                                border: 1px solid #5a6ef9;
                                border-radius: 10px;
                                z-index: 200;
                                margin: 10px;
                            "
                            :v-model="optionIndex"
                            @click="submit($event)"
                            :data-index="optionIndex"
                        >
                            {{ option }}
                        </div>
                    </div>
                    <!-- 填空题 -->
                    <div
                        class="panel-bd option2"
                        v-if="answerList[topicIndex]&&answerList[topicIndex].type == 3"
                    >
                        <template
                            v-if="
                                answerList[topicIndex].answerFormat == 'time' ||
                                answerList[topicIndex].answerFormat == 'time2' ||
                                answerList[topicIndex].answerFormat == 'time3' ||
                                answerList[topicIndex].answerFormat == 'age'
                            "
                        >
                            <div style="display: flex; margin: 16px 0">
                                <div class="tit_class" style="width: 240px">
                                    {{ (answerList[topicIndex].answer) || (answerList[topicIndex].answer == 0) ? '您的选择：': '请选择'}}
                                </div>
                                <select
                                    v-model="answerList[topicIndex].answerIndex"
                                    class="checkIndex"
                                    @change="onConfirm($event)"
                                >
                                    <option
                                        v-for="(time, timeIndex) in (answerList[topicIndex].answerFormat == 'age') ?
                                        ageArr :(answerList[topicIndex].answerFormat == 'time3') ?
                                        timeArr3 :(answerList[topicIndex].answerFormat == 'time2') ?
                                        timeArr2 :timeArr"
                                        :key="timeIndex"
                                        :value="timeIndex"
                                    >
                                    {{
                                        ( answerList[topicIndex].answerFormat ) == 'age' ?
                                        ( time ) + '岁' :
                                        ( answerList[topicIndex].answerFormat ) == 'time3' ?
                                        ( time ) + '个月' :
                                        ( time )
                                    }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div
                class="doIng"
                style="
                    width: 100%;
                    position: fixed;
                    bottom: 0px;
                    padding: 20px 0;
                    height: 60px;
                "
            >
                <van-button
                    v-if="topicIndex == 0"
                    style="
                        margin: 5px 10px 5px 0;
                        height: 50px;
                        line-height: 50px;
                        font-size: 20px;
                        width: 140px;
                        padding: 0;
                        border-radius: 4px;
                        position: fixed;
                        right: 165px;
                    "
                    class="last_d_actionBtn"
                    disabled
                >
                    上一题
                </van-button>
                <van-button
                    v-else
                    style="
                        margin: 5px 10px 5px 0;
                        height: 50px;
                        width: 140px;
                        padding: 0;
                        line-height: 50px;
                        font-size: 20px;
                        border-radius: 4px;
                        position: fixed;
                        right: 165px;
                    "
                    class="last_actionBtn"
                    type="second"
                    @click="last"
                >
                    上一题
                </van-button>

                <van-button
                    v-if="answerList[topicIndex]&&answerList[topicIndex].type > 2 && disabled == true"
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        width: 140px;
                        height: 50px;
                        border-radius: 4px;
                    "
                    class="actionBtn"
                    type="parent"
                    @click="next"
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>
                <van-button
                    v-if="answerList[topicIndex]&&answerList[topicIndex].type > 2 && disabled == false"
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        width: 140px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        height: 50px;
                        border-radius: 4px;
                    "
                    class="actionBtn1"
                    type="parent"
                    disabled
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>

                <van-button
                    v-if="
                        answerList[topicIndex]&&!answerList[topicIndex].isFinish &&
                        answerList[topicIndex]&&answerList[topicIndex].type <= 2 &&
                        disabled == true
                    "
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        width: 140px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        height: 50px;
                        border-radius: 4px;
                    "
                    class="actionBtn"
                    type="parent"
                    @click="next"
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>
                <van-button
                    v-if="
                        answerList[topicIndex]&&!answerList[topicIndex].isFinish &&
                        answerList[topicIndex]&&answerList[topicIndex].type <= 2 &&
                        disabled == false
                    "
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        width: 140px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        height: 50px;
                        border-radius: 4px;
                    "
                    disabled
                    class="actionBtn1"
                    type="parent"
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>
                <van-button
                    v-if="
                        answerList[topicIndex]&&answerList[topicIndex].isFinish == 1 &&
                        answerList[topicIndex]&&answerList[topicIndex].type <= 2 &&
                        disabled == true
                    "
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        width: 140px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        height: 50px;
                        border-radius: 4px;
                    "
                    class="actionBtn"
                    type="parent"
                    @click="next"
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>
                <van-button
                    v-if="
                        answerList[topicIndex]&&answerList[topicIndex].isFinish == 1 &&
                        answerList[topicIndex]&&answerList[topicIndex].type <= 2 &&
                        disabled == false
                    "
                    style="
                        margin: 5px 0px;
                        position: fixed;
                        right: 10px;
                        width: 140px;
                        line-height: 50px;
                        font-size: 20px;
                        padding: 0;
                        height: 50px;
                        border-radius: 4px;
                    "
                    class="actionBtn1"
                    type="parent"
                    disabled
                >
                    <span v-if="topicIndex + 1 < answerList.length"
                        >下一题</span
                    >
                    <span v-else>提交</span>
                </van-button>
            </div>
        </div>
        <div class="dialog" v-if="isFamilyType">
            <div class="box">
                <!-- <div class="close">x</div> -->
                <p class="title">请选择学生家庭类型</p>
                <van-radio-group v-model="familyType" direction="horizontal">
                    <van-radio :name="1" icon-size="24px">双亲</van-radio>
                    <van-radio :name="2" icon-size="24px">单亲（父亲）</van-radio>
                    <van-radio :name="3" icon-size="24px">单亲（母亲）</van-radio>
                </van-radio-group>
                <button class="goBtn" @click="affirm">确认</button>
            </div>
        </div>
    </div>
</template>
<script>
    import { examStart, examEnd } from "@/api/api";
    import { mapGetters } from 'vuex'
    export default {
        name: "component_name",
        data () {
            return {
                clientHeight: document.body.clientHeight,
                showPicker: false,
                checkTime: "",
                timeArr: [
                    "00:00",
                    "00:30",
                    "01:00",
                    "01:30",
                    "02:00",
                    "02:30",
                    "03:00",
                    "03:30",
                    "04:00",
                    "04:30",
                    "05:00",
                    "05:30",
                    "06:00",
                    "06:30",
                    "07:00",
                    "07:30",
                    "08:00",
                    "08:30",
                    "09:00",
                    "09:30",
                    "10:00",
                    "10:30",
                    "11:00",
                    "11:30",
                    "12:00",
                    "12:30",
                    "13:00",
                    "13:30",
                    "14:00",
                    "14:30",
                    "15:00",
                    "15:30",
                    "16:00",
                    "16:30",
                    "17:00",
                    "17:30",
                    "18:00",
                    "18:30",
                    "19:00",
                    "19:30",
                    "20:00",
                    "20:30",
                    "21:00",
                    "21:30",
                    "22:00",
                    "22:30",
                    "23:00",
                    "23:30",
                ],
                timeArr2: ['0小时0分钟', '0小时30分钟', '1小时0分钟', '1小时30分钟', '2小时0分钟', '2小时30分钟', '3小时0分钟', '3小时30分钟', '4小时0分钟', '4小时30分钟', '5小时0分钟', '5小时30分钟', '6小时0分钟', '6小时30分钟', '7小时0分钟', '7小时30分钟', '8小时0分钟', '8小时30分钟', '9小时0分钟', '9小时30分钟', '10小时0分钟', '10小时30分钟', '11小时0分钟', '11小时30分钟', '12小时0分钟', '12小时30分钟', '13小时0分钟', '13小时30分钟', '14小时0分钟', '14小时30分钟', '15小时0分钟', '15小时30分钟', '16小时0分钟', '16小时30分钟', '17小时0分钟', '17小时30分钟', '18小时0分钟', '18小时30分钟', '19小时0分钟', '19小时30分钟', '20小时0分钟', '20小时30分钟', '21小时0分钟', '21小时30分钟', '22小时0分钟', '22小时30分钟', '23小时0分钟', '23小时30分钟'],
                timeArr3:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100],
                ageArr:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100],
                topicCount: 5,
                answerList: [],
                questionNum: 0,
                topicIndex: 0,
                showAll: false,
                disabled: false,
                name: "",
                startTime: 0,
                mode: 1,
                isFamilyType: 0,
                familyType: 0
            };
        },
        computed: {
            ...mapGetters(['examId'])
        },
        created () {
            // 获取窗口高度
            if (window.innerHeight) this.clientHeight = window.innerHeight
            else if (document.body && document.body.clientHeight)
            this.clientHeight = document.body.clientHeight
            this.token = window.localStorage.getItem("token")
            this.studentId = window.localStorage.getItem("studentId")
        },
        mounted () {
            this.mode = Number(this.$route.query.mode) || 1
            // 父母养育量表 
            const isFamilyType = Number(window.localStorage.getItem("is_familyType"))
            this.familyType = isFamilyType
            console.log(isFamilyType)
            if (isFamilyType && this.mode == 1) {
                this.isFamilyType = isFamilyType
            } else {
                this.getTopic();
            }
            const that = this;
            window.onresize = () => {
                return (() => {
                    window.screenHeight = document.body.clientHeight;
                    that.clientHeight = window.screenHeight;
                })();
            };
        },
        methods: {
            affirm(){
                if (this.familyType) {
                    this.isFamilyType = 0
                    this.getTopic()
                }
            },
            report: function () {
                let endTime = new Date()
                let spendTime = Math.round((endTime - this.startTime) / 1000)
                var answers = [],
                    answer = {};
                var miss = [];
                var answerList = this.answerList;

                answerList.forEach((element, index) => {
                    answer = {};
                    answer.id = element.id;
                    if (element.answer === undefined) {
                        miss.push("第" + (index + 1) + "题");
                        if (element.type < 3) {
                            answer.a = 0;
                        } else if (element.answerFormat == "time") {
                            answer.a = this.timeArr[0];
                        } else if (element.type === 4) {
                            answer.a = element.answers.toString()
                        } else {
                            answer.a = "";
                        }
                    } else {
                        answer.a = element.answer;
                    }

                    if (element.hasExtra) {
                        answer.answerExtra = element.answerExtra || "";
                    }
                    answers.push(answer);
                });
                this.$toast.loading({
                    message: "提交中",
                    forbidClick: true,
                });

                var data = {
                    token: this.token,
                    examId: this.examId,
                    answers: answers,
                    studentId: this.studentId,
                    timeUsed: spendTime,
                    clientType: 1
                };
                if (this.familyType) {
                    data.familyType = this.familyType
                }
                this.loading = true;
                examEnd(data)
                    .then((res) => {
                        // console.log(res, "成功");
                        this.$toast.success("提交成功！");
                        this.answerList = [];
                        this.topicIndex = 0;
                        // 清除答题记录
                        window.localStorage.removeItem('topics_' + this.studentId)
                        window.localStorage.removeItem('topicIndex_' + this.studentId)
                        window.localStorage.removeItem('topicProgress_' + this.studentId)
                        this.$router.push({
                            path: "/report",
                            query: {
                                testingId: res.data.testingNo,
                            },
                        });
                    })
                    .catch((err) => {
                        console.log(err);
                        this.loading = false
                        this.disabled = false
                    });
            },

            submit (e) {
                // e.target 是你当前点击的元素
                // e.currentTarget 是你绑定事件的元素
                // if (this.disabled) {
                //   return
                // }

                this.disabled = true;
                var topicIndex = this.topicIndex;
                var answerList = JSON.parse(JSON.stringify(this.answerList))
                var type = answerList[topicIndex].type;
                var answer,
                    answerIndex = "",
                    answers = [];
                let answerObj = {}

                var isFinish = 0;
                const index = e.target.dataset.index
                let prefix = []
                if (answerList[topicIndex].prefix) {
                    prefix = answerList[topicIndex].prefix.split(',').map(Number);
                }
                switch (type) {
                    case 1:
                        answer = e.target.dataset.index;
                        answerIndex = e.target.dataset.index;
                        isFinish = 1;
                        break;
                    case 2:
                        answerIndex = e.target.dataset.index;
                        answer = e.target.dataset.index;
                        isFinish = 1;
                        break;
                    case 3:
                        answerIndex = e.target.dataset.index;
                        answer = e.target.dataset.index;
                        isFinish = 1;
                        break;
                    case 4:
                        answers = answerList[topicIndex].answers || [];
                        answerObj = answerList[topicIndex].answerObj || {};
                        if (answers.indexOf(index) > -1) {
                            answers.splice(answers.indexOf(index), 1)
                            answerObj[index] = false
                        } else {
                            if (answers.length < prefix[1]) {
                                answers.push(index)
                                answerObj[index] = true
                            }
                        }
                        isFinish = (answers.length >= prefix[0] && answers.length <= prefix[1]) ? 1 : 0
                        break;
                    default:
                        break;
                }
                // console.log("answer:" + answer, "answerIndex:" + answerIndex);
                var isDone = type > 2 ? 0 : answerList[topicIndex].isDone;

                if (type != 4) {
                    answerList[topicIndex].answer = answer
                    answerList[topicIndex].answerIndex = answerIndex
                    answerList[topicIndex].isFinish = isFinish
                    this.answerList = answerList
                    if (isFinish) {
                        this.disabled = true;
                    } else {
                        this.disabled = false;
                    }

                    // console.log("isFinish", isFinish, 'isDone', isDone);
                    if (isFinish && !isDone) {
                        setTimeout(this.next(), "500");
                    }
            } else {
                answerList[topicIndex].answerObj = answerObj
                answerList[topicIndex].answers = answers
                answerList[topicIndex].isFinish = isFinish
                this.answerList = answerList
                if (isFinish) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
            }
            // console.log(answerList[topicIndex]);


            },
            last: function () {
                var topicIndex = this.topicIndex;

                this.disabled = true;

                if (topicIndex > 0) {
                    this.topicIndex = topicIndex - 1;
                    // this.disabled=false
                }
            },
            next: function () {
                // window.clearInterval(interval);
                var topicIndex = this.topicIndex;
                var answerList = this.answerList;
                this.answerList[topicIndex].isDone = 1;
                window.localStorage.setItem('topics_' + this.studentId, JSON.stringify(answerList));
                window.localStorage.setItem('topicIndex_' + this.studentId, topicIndex);

                let progress = topicIndex * 100 / answerList.length
                progress = progress > 10 ? progress.toFixed(1) : progress.toFixed(2)
                window.localStorage.setItem('topicProgress_' + this.studentId, progress);
                this.disabled = true;

                if (topicIndex + 1 < answerList.length) {
                    this.topicIndex = topicIndex + 1
                    if (this.answerList[this.topicIndex].isFinish) {
                        this.disabled = true
                    } else {
                        this.disabled = false
                    }
                } else {
                    this.report();
                }
            },
            onConfirm (e) {
                let topicIndex = this.topicIndex;
                let answer
                if (this.answerList[topicIndex].answerFormat == 'age' || this.answerList[topicIndex].answerFormat == 'time3') {
                    answer = this.ageArr[e.target.value];
                }else{
                    answer = this.timeArr[e.target.value];
                }
                this.answerList[topicIndex].answer = answer
                this.answerList[topicIndex].isFinish = 1;
                this.answerList[topicIndex].answerIndex = e.target.value
                this.showPicker = false;
                this.disabled = true;
            },
            getTopic: function () {
                let query = {
                    token: this.token,
                    examId: this.examId,
                    studentId: this.studentId,
                    familyType: this.familyType,
                    // clientType: 1
                };

                examStart(query)
                    .then((res) => {
                        // console.log(res, "数据");
                        var name = res.data.exam.name;
                        window.document.title = name;
                        this.name = res.data.exam.name;
                        this.answerList = res.data.list;
                        this.questionNum = res.data.questionNum;
                        this.startTime = new Date()
                        // 上次答题记录
                        if (this.mode == 2) {
                            const topicIndex = window.localStorage.getItem(`topicIndex_${this.studentId}`)
                            this.topicIndex = Number(topicIndex)
                            this.answerList = JSON.parse(window.localStorage.getItem(`topics_${this.studentId}`))
                            this.questionNum = this.answerList.length
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
        },
    };
</script>
<style lang="less" scoped>
// 遮罩层
.dialog{
    position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	left: 0;
	background-color: rgba(90, 90, 90, 0.5);
	z-index: 1;
    .box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        border-radius: 3px;
        margin: 30px auto;
        width: 200px;
        background-color: #fff;
        padding: 20px 0;
        .close{
            font-size: 10px;
            color: #9d9999;
            text-align: center;
            position:absolute;
            line-height: 10px;
            top:2px;
            right: 2px;
            width: 10px;
            height: 10px;
            cursor: pointer;
        }
        .title{
            margin-top: 0.03667rem;
            padding: 0;
            height: 5px;
            font-size: 5px;
            text-align: center;
        }

        .goBtn{
            min-width: 60px;
            margin: 0 auto;
            cursor: pointer;
            padding: 3px 5px;
            font-size: 4px;
            color:#fff;
            margin-top: 10px;
            border: #5a6ef9;
            background-color: #5a6ef9;
            border-radius: 1px;
            &:hover{
                background-color: #8e9cf5;
            }
        }
    }
}
    .tit_class {
        height: 20px;
        line-height: 20px;
        font-size: 6px;
    }
    .checkIndex {
        width: 75%;
        box-sizing: border-box;
        height: 20px;
        line-height: 20px;
        background-color: #f1f1f1;
        border-radius: 5px;
        padding-left: 5px;
        font-size: 8px;
        border: 0px solid #f1f1f1;
    }
    .panel {
        margin: 5px 0px;
        // border-radius: 10px;
        padding: 5px 10px 10px;
        background-color: #ffffff;
        box-shadow: #00000023 0 4px 12px;
        overflow: hidden;
    }
    body {
        background: #5a6ef9;
    }
    .last_d_actionBtn {
        background-color: #f7f7f7;
        color: #cccccc;
        height: 24px;
        line-height: 24px;
        font-size: 10px;
        border-radius: 5px;
    }
    .last_actionBtn {
        background-color: #ffffff;
        color: #333333;
        height: 24px;
        line-height: 24px;
        font-size: 10px;
        border-radius: 5px;
    }
    .actionBtn1 {
        //  width: 130px;
        // padding: 0;
        // height: 24px;
        // line-height: 24px;
        // font-size: 10px;
        background-color: #ede7f6;
        color: #ffffff;
        border-radius: 5px;
        text-align: center;
    }
    .actionBtn {
        // padding: 0;
        // display: flex;
        // flex-flow: row;
        // justify-content: center;
        // height: 24px;
        // line-height: 24px;
        // font-size: 10px;
        background-color: #5a6ef9;
        color: #ffffff;
        border-radius: 5px;
        text-align: center;
        border: 0px solid #5a6ef9;
    }

    .doIng {
        background: #ffffff;
        text-align: right;
        // position: fixed;
        // bottom: 0;
        display: flex;
        z-index: 999;
    }
    .progress {
        color: #596df8;
        text-align: right;
        font-size: 6px;
    }
    .active-cell {
        position: static;
        box-sizing: border-box;
        padding: 0;
        margin: 8px 0 10px;
        display: flex;
        align-items: flex-start;
        border: none;

        .van-cell--large .van-cell__title {
            font-size: 6px;
        }

        /deep/ .van-field__label {
            height: 20px;
            line-height: 20px;
            font-size: 6px;
        }

        /deep/ .van-field__control {
            box-sizing: border-box;
            height: 20px;
            line-height: 20px;
            background-color: #f1f1f1;
            border-radius: 5px;
            padding-left: 10px;
            font-size: 6px;
        }
    }
    .option1 {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
    }
    .optionItem1 {
        font-size: 6px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        background-color: #ffffff;
        padding: 2px 10px;
        margin: 5px;
        width: 260px;
        align-items: center;
        border: 1px solid #333333;
        border-radius: 6px;
        z-index: 200;
    }
    .optionItem1:active {
        font-size: 6px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        background-color: #5a6ef9;
        border: 1px solid #5a6ef9;
        padding: 2px 10px;
        margin: 5px;
        width: 260px;
        align-items: center;
        color: white;
        border-radius: 6px;
        z-index: 200;
    }
    .check_optionItem1 {
        font-size: 6px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        background-color: #5a6ef9;
        border: 1px solid #5a6ef9;
        padding: 2px 10px;
        margin: 5px;
        width: 260px;
        align-items: center;
        color: white;
        border-radius: 6px;
        z-index: 200;
    }
    .check_optionItem2 {
        // font-size: 6px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        background-color: #5a6ef9;
        border: 1px solid #5a6ef9;
        color: white;
        // padding: 2px 10px;
        // margin: 5px;
        // align-items: center;
        // border-radius: 6px;
        // z-index: 200;
    }
    .optionItem2 {
        // font-size: 6px;
        display: flex;
        flex-flow: row;
        justify-content: center;
        // background-color: #ffffff;
        // padding: 2px 10px;
        // margin: 5px;
        // align-items: center;
        // border: 1px solid #333333;
        // border-radius: 6px;
        // z-index: 200;
    }
    .optionItem2:active {
        // font-size: 6px;
        // display: flex;
        // flex-flow: row;
        // justify-content: center;
        background-color: #5a6ef9;
        border: 1px solid #5a6ef9;
        // padding: 2px 10px;
        // margin: 5px;
        // align-items: center;
        color: white;
        // border-radius: 6px;
        // z-index: 200;
    }

    .tit {
        font-size: 6px;
        font-weight: bold;
    }
    .tit1 {
        // font-size: 8px;
        font-weight: bold;
        text-align: center;
        // margin-bottom: 5px;
    }
    .questionTypeName {
        font-size: 6px;
        color: #ffffff;
        background-color: #5a6ef9;
        border-radius: 24px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        width: 36px;
        margin: 4px 0;
    }
    // .panel {
    //   display: flex;
    //   flex-flow: column;
    //   background-color: #ffffff;
    //   padding: 10px 20px;
    //   border-radius: 10px;
    //   margin: 10px 60px 100px;
    //   box-shadow: 0px 10px 20px 0px rgba(90, 110, 249, 0.2);
    // }

    .panel:first-child {
        margin: 0 auto 30rpx;
    }

    .panel-hd {
        display: flex;
        flex-flow: row;
        font-size: 32rpx;
        color: #333333;
        align-items: center;
        justify-content: space-between;
        margin: 5rpx 0;
        border-radius: 12rpx;
    }

    .panel-hd .left {
        font-size: 24rpx;
        color: #666666;
    }

    .panel-bd {
        color: #333333;
        margin: 0;
        /* background-color: #fff9f9; */
        padding: 20rpx;
        border-radius: 12rpx;
    }
    .panel-bd1 {
        color: #333333;
        margin: 0;
        /* background-color: #fff9f9; */
        padding: 4px 10px;
        border-radius: 30rpx;
    }

    .panel-ft {
        display: flex;
        flex-flow: row;
        font-size: 24rpx;
        color: #999999;
        align-items: center;
        justify-content: space-between;
        margin: 20rpx 0 0;
    }

    .panel:last-child {
        margin-bottom: 80rpx;
    }
</style>